import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';

import { ToastService } from 'src/app/services/toast.service';

import { MemberPaths } from 'src/app/constants/routes';
import { ToastType } from 'src/app/constants/toast-type';
import { SessionService } from '../services/storage/session.service';

@Injectable()
export class PayrollGuard implements CanActivate {

    constructor(
        private sessionService: SessionService,
        private toastService: ToastService,
        private router: Router,
    ) {
    }

    public canActivate(): Observable<boolean> {
        if (!this.sessionService.session?.member.usePayrollModule || this.sessionService.session.isAgent) {
            if (this.sessionService.session.isAgent)
                this.toastService.buildToastMessage(ToastType.warning, 'Access Denied', 'Payroll Module is for Members Only!');
            else
                this.toastService.buildToastMessage(ToastType.warning, 'Access Denied', 'Payroll Module not activated for this company!');
            this.router.navigateByUrl(MemberPaths.Dashboard);
            return of(false);
        }

        return of(true);
    }
}